<template>
  <div>
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 4"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <personalinvoice-index @id="setId" :active="{ active }"></personalinvoice-index>
    </el-form>
    <el-form v-if="active === 2">
      <invoice-view :id="invoice_id"></invoice-view>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "DatatableWithFilter",
  data() {
    return {
      active: 1,
      invoice_id: 0,
    };
  },
  methods: {
    setId(id) {
      this.active = 2;
      this.invoice_id = id;
    },
    previous() {
        this.active = 1;
    },
  },
};
</script>
